<template>
  <main class="page-main">
    <div class="uk-grid" data-uk-grid>
      <!-- 主要内容 -->
      <div class="uk-width-2-3@l">
        <div class="widjet --tutorial">
          <div class="widjet__head">
            <h3 class="uk-text-lead">📚 教程中心</h3>
          </div>
          <div class="widjet__body">
            <div class="tutorial-section">
              <!-- 视频教程 -->
              <h2 class="section-title">📺 视频教程 - 一看就懂</h2>
              <div class="video-tutorial">
                <a href="https://47.122.120.229/ios/ios1.mp4" target="_blank">
                  <img src="@/assets/img/20241101205614wLHQ.jpg" alt="视频教程" class="video-thumbnail" />
                </a>
              </div>

              <!-- 重要链接图片 -->
              <div class="link-section">
                <a href="https://ok.realsulian.com" target="_blank">
                  <img src="@/assets/img/20241030220313qUZb.jpg" alt="重要链接" class="link-img" />
                </a>
              </div>

              <!-- 图文教程 -->
              <h2 class="section-title">📝 图文教程 - 仅需两步</h2>
              <p class="description"><strong>第一步：安装小火箭加速</strong></p>
              <p class="description">先切换美区 ID 账号 <span class="highlight">（免费）</span></p>
              <img src="@/assets/img/20241030214318EPpS.jpg" alt="安装小火箭" class="tutorial-img" />

              <p class="description"><strong>第二步：导入订阅</strong></p>
              <p class="description">复制订阅链接，手动导入</p>
              <img src="@/assets/img/20241030214332UqNI.png" alt="导入订阅" class="tutorial-img" />

              <p class="description"><strong>打开软件开关，连接网络</strong></p>
              <img src="@/assets/img/20241030214335tiEn.jpg" alt="连接网络" class="tutorial-img" />

              <p class="description"><strong>最终效果</strong></p>
              <img src="@/assets/img/20241030214333zhCp.jpg" alt="最终效果" class="tutorial-img" />
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧附加信息 -->
      <div class="uk-width-1-3@l">
        <div class="widjet --support">
          <div class="widjet__head">
            <h3 class="uk-text-lead">🔍 常见问题 & 解决方案</h3>
          </div>
          <div class="widjet__body">
            <!-- FAQ 列表 -->
            <div class="section">
              <h2 class="section-title">📌 常见问题</h2>
              <ul class="faq-list">
                <li>💡 <strong>订阅导入失败？</strong><br />请检查是否已在官网兑换，未兑换成功导入会失败。</li>
                <li>📌 <strong>TikTok 无法使用？</strong><br />请拔掉 SIM 卡，切换到美国地区，并使用美国节点。</li>
                <li>🧠 <strong>ChatGPT 访问受限？</strong><br />请连接带 GPT 字样的美国节点，并清理浏览器缓存。</li>
              </ul>
            </div>

            <!-- 线路测试 -->
            <div class="section">
              <h2 class="section-title">🚀 线路测试</h2>
              <p class="faq-text">请点击下方链接测试网络连接情况</p>
              <a href="http://google.com/" target="_blank" class="test-btn">测试 Google 访问</a>
              <img src="@/assets/img/20241030214338Htdi.png" alt="测试 Google 访问" class="test-img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "TutorialPage",
};
</script>

<style scoped>
/* 🌟 页面整体布局 */
.page-main {
  width: 100%;
  padding: 20px;
  background: #f9f9f9;
}

/* 🌟 主要内容区 */
.widjet {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.widjet__head h3 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

/* 🌟 标题样式 */
.section-title {
  font-size: 20px;
  font-weight: bold;
  color: rgb(54, 113, 185);
  margin-bottom: 10px;
}

/* 🌟 文字描述 */
.description {
  font-size: 18px;
  color: #555;
  line-height: 1.6;
  margin-bottom: 15px;
}

.highlight {
  color: #e74c3c;
  font-weight: bold;
}

/* 🌟 视频教程 */
.video-tutorial {
  text-align: center;
}

.video-thumbnail {
  width: 100%;
  max-width: 400px;
  border-radius: 10px;
  cursor: pointer;
  transition: transform 0.3s;
}

.video-thumbnail:hover {
  transform: scale(1.05);
}

/* 🌟 重要链接图片 */
.link-section {
  text-align: center;
  margin-top: 15px;
}

.link-img {
  width: 100%;
  max-width: 400px;
  border-radius: 10px;
  cursor: pointer;
  transition: transform 0.3s;
}

.link-img:hover {
  transform: scale(1.05);
}

/* 🌟 图文教程 */
.tutorial-img {
  width: 100%;
  max-width: 700px;
  border-radius: 10px;
  margin-bottom: 15px;
}

/* 🌟 FAQ 列表 */
.faq-list {
  padding: 0;
  list-style: none;
}

.faq-list li {
  font-size: 18px;
  color: #444;
  margin-bottom: 10px;
}

/* 🌟 测试按钮 */
.test-btn {
  display: inline-block;
  margin-top: 10px;
  padding: 10px 15px;
  font-size: 18px;
  font-weight: bold;
  color: white;
  background-color: #28a745;
  text-decoration: none;
  border-radius: 5px;
  text-align: center;
  transition: background 0.3s;
}

.test-btn:hover {
  background-color: #218838;
}

/* 🌟 测试图片 */
.test-img {
  width: 100%;
  max-width: 400px;
  margin-top: 10px;
}

/* 🌟 响应式优化 */
@media (max-width: 600px) {
  .widjet {
    padding: 15px;
  }

  .section-title {
    font-size: 18px;
  }

  .description {
    font-size: 16px;
  }

  .test-btn {
    font-size: 16px;
    padding: 8px 12px;
  }
}
</style>
